import { render } from "./TeamPriorities.vue?vue&type=template&id=1bdf0560&scoped=true"
import script from "./TeamPriorities.vue?vue&type=script&lang=js"
export * from "./TeamPriorities.vue?vue&type=script&lang=js"

import "./TeamPriorities.vue?vue&type=style&index=0&id=1bdf0560&scoped=true&lang=css"

import exportComponent from "/var/www/compass/production/releases/20251103101657/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdf0560"]])

export default __exports__